export const endpoints = {
  envioCorreos: '/correos',
};
